import React from 'react';
import { List, ListItem, ListItemText, Typography } from '@mui/material';
import { Problem } from '../../models/Problem';
import { StyledListContainer } from './ProblemStyles';
import { useProblem } from '../../hooks/useProblem';

interface ProblemListProps {
  onSelectProblem: (problem: Problem) => void;
}

const ProblemList: React.FC<ProblemListProps> = ({ onSelectProblem }) => {
  const { problems } = useProblem();

  // console.log('problems', problems);

  return (
    <StyledListContainer>
      <List>
        {problems.map(problem => {
          return (
            <ListItem button key={problem.id} onClick={() => onSelectProblem(problem)}>
              <ListItemText
                primary={problem.title}
                secondary={
                  <>
                    <Typography component="span" variant="body2" color="textPrimary">
                      Status: {problem.status}
                    </Typography>
                    {/*{problem.status === 'completed' && (*/}
                    {/*  <Typography component="span" variant="body2" color="textSecondary">*/}
                    {/*    {` - Subtasks: ${subtaskCount}`}*/}
                    {/*  </Typography>*/}
                    {/*)}*/}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </StyledListContainer>
  );
};

export default ProblemList;
